<!--
    tip:  compare w/ src/pages/associate/Reports/Index.vue
-->
<template>
  <main-layout
    margin-top="0px"
  >
    <div v-if="dataRange">
      <div>
        <div
          v-if="isIntegrated && customUrl"
          class="row mb-4"
        >
          <div class="col-12 pt-2">
            <admin-sales-summary-container
              :data-range="dataRange"
              @hasCustomUrl="onCustomUrl"
            />
          </div>
        </div>
      </div>
      <div v-show="!customUrl">
        <div
          v-if="isIntegrated"
          class="row mb-4"
        >
          <div class="col-12 pt-2">
            <admin-sales-summary-container
              :data-range="dataRange"
              @hasCustomUrl="onCustomUrl"
            />
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <base-card class="data-range">
            <div class="row">
              <div class="col-12">
                <div class="row sticky">
                  <div class="col-12">
                    <data-range-selector v-model="dataRange" />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <admin-activity-container :data-range="dataRange" />
              </div>
              <div class="col-6">
                <admin-team-performance-chart-container :data-range="dataRange" />
              </div>
            </div>
          </base-card>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <admin-outreach-container :data-range="dataRange" />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <admin-chart-container :data-range="dataRange" />
        </div>
      </div>

      <div class="row my-4">
        <div class="col-12">
          <!--
              API CALLS
                - /institution/25/device_stats_range/?range=ytd
                - /institution/25/stats_range/?range=ytd
                - /outreach/?onlysent=true&period=ytd&page_size=5&page=1&with_appointments=true&scope=manager
          -->
          <admin-top-information-container :data-range="dataRange" />
        </div>
      </div>
    </div>
    <div v-else>
      <!--
      Oh no 😢  'dataRange' was falsy!  --&lt; {{ dataRange }}
      -->
    </div>
  </main-layout>
</template>
<script>

import DataRangeSelector from '@/components/Widgets/Reports/DataRangeSelector';
import integrable from '@/components/mixins/integrable';
import AdminOutreachContainer from '@/components/Widgets/AdminReports/AdminOutreachContainer';
import AdminTeamPerformanceChartContainer from '@/components/Widgets/AdminReports/AdminTeamPerformanceChartContainer';
import AdminSalesSummaryContainer from '@/components/Widgets/AdminReports/AdminSalesSummaryContainer';
import AdminTopInformationContainer from '@/components/Widgets/AdminReports/AdminTopInformationContainer';
import AdminChartContainer from '@/components/Widgets/AdminReports/AdminChartContainer';

export default {
  name: 'AdminIndexReports',
  components: {
    DataRangeSelector,
    AdminSalesSummaryContainer,
    AdminOutreachContainer,
    AdminTeamPerformanceChartContainer,
    AdminTopInformationContainer,
    AdminChartContainer,
  },
  mixins: [integrable],
  data() {
    return {
      dataRange: this.institutionDefaultDataRange,
      customUrl: false,
    };
  },
  computed: {
    institutionId() {
      return this.$store.state.account.user.profile.institution.pk;
    },
    institutionDefaultDataRange() {
      return this.$store.state.account.user.profile.institution.reports_time_range;
    },
  },
  watch: {
    dataRange(newDataRange, oldDataRange) {
      // console.log(`WATCH [dataRange] oldDataRange: ${oldDataRange}   newDataRange: ${newDataRange}`);
      this.fetchStats();
    },
    institutionDefaultDataRange: {
      handler(newval) {
        // console.log(`WATCH [institutionDefaultDataRange]  newval: ${newval}    arguments.length: ${arguments.length}`);
        if (newval && !this.dataRange) {
          this.dataRange = newval;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    /* 7/12/21 dlam: comment out to avoid multiple API calls to /profile/stats_range/ */
    // this.fetchStats();
  },
  methods: {
    fetchStats() {
      if (this.dataRange) {
        this.$store.dispatch('institutions/fetchStats', {
          id: this.institutionId,
          range: this.dataRange,
        });
      } else {
        console.warn(`'dataRange' was falsy in fetchStats(): ${this.dataRange}`);
      }
    },
    onCustomUrl() {
      this.customUrl = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.sticky {
  position: sticky;
  position: -webkit-sticky;
  /* Safari */
  top: 60px;
  z-index: 10;
}
.data-range{
  ::v-deep .card-body{
    padding: 10px;
  }
}
</style>
